import tabs from 'views/challenge/tabs';
import types from 'views/challenge/types';

export default {
	...tabs,
	...types,
};
